<div class="plano-card plano-card-clicavel" (click)="navegarParaPlanos()">
  <div class="card-header">
    <div class="header-left">
      <i class="pi pi-tag"></i>
      <span class="header-titulo">{{ texts.planos }}</span>
    </div>
    <button pButton type="button"
            icon="pi pi-whatsapp"
            class="p-button-rounded p-button-text p-button-success"
            (click)="abrirWhatsAppPlanos(); $event.stopPropagation()">
    </button>
  </div>

  <p-divider></p-divider>

  <!-- Estado: empresa tem plano ativo -->
  <ng-container *ngIf="temPlano; else semPlano">
    <div class="plano-info">
      <div class="plano-detalhes">
        <span class="plano-label">{{ texts.plano_atual }}</span>
        <span class="plano-nome">{{ planoNome }}</span>
        <span class="plano-descricao">{{ planoDescricao }}</span>
      </div>
      <!-- Uso do plano: plano ESPECIAL nao tem limite de vendas -->
      <div class="plano-uso">
        <ng-container *ngIf="!ehPlanoEspecial; else usoSemLimite">
          <p-knob [ngModel]="percentualUsoPlano"
                  [readonly]="true"
                  [size]="80"
                  valueColor="#165c7d"
                  rangeColor="#e0e0e0"
                  [valueTemplate]="percentualUsoPlano + '%'">
          </p-knob>
          <span class="uso-label">{{ texts.uso_do_plano }}</span>
        </ng-container>
        <ng-template #usoSemLimite>
          <i class="pi pi-infinity plano-uso__infinito" aria-hidden="true"></i>
          <span class="uso-label">{{ texts.sem_limite_vendas }}</span>
        </ng-template>
      </div>
    </div>

    <!-- Vencimento: ESPECIAL nao vence; planoStart nao exibe -->
    <div class="vencimento-section" *ngIf="!ehPlanoStart">
      <span class="vencimento-titulo">{{ texts.vencimento }}</span>
      <ng-container *ngIf="!ehPlanoEspecial; else semVencimento">
        <p-progressBar [value]="percentualVencimento" [showValue]="false" styleClass="vencimento-bar"></p-progressBar>
        <div class="vencimento-info">
          <span>{{ texts.dias_restantes }}: <strong>{{ diasRestantesLabel }}</strong></span>
          <span>{{ texts.data_de_vencimento }}: <strong>{{ dataVencimentoFormatada }}</strong></span>
        </div>
      </ng-container>
      <ng-template #semVencimento>
        <div class="vencimento-info vencimento-info--sem">
          <i class="pi pi-infinity" aria-hidden="true"></i>
          <strong>{{ texts.sem_vencimento }}</strong>
        </div>
      </ng-template>
    </div>

    <!-- Fechamento do ciclo (reinicio do limite): nao se aplica ao ESPECIAL -->
    <div class="ciclo-info" *ngIf="!ehPlanoEspecial && dataFechamentoCicloFormatada">
      <i class="pi pi-sync ciclo-info__icon" aria-hidden="true"></i>
      <span>{{ texts.fechamento_ciclo }}: <strong>{{ dataFechamentoCicloFormatada }}</strong></span>
    </div>
  </ng-container>

  <!-- Estado: empresa sem plano ativo -->
  <ng-template #semPlano>
    <div class="sem-plano">
      <i class="pi pi-info-circle sem-plano-icone"></i>
      <span class="sem-plano-texto">{{ texts.sem_plano_ativo }}</span>
      <button pButton type="button"
              class="p-button-sm p-button-outlined"
              [label]="texts.contratar_plano"
              icon="pi pi-arrow-right"
              iconPos="right"
              (click)="abrirWhatsAppPlanos(); $event.stopPropagation()">
      </button>
    </div>
  </ng-template>
</div>
